export const pixelRatio = () => {
  const density = Math.round(window.devicePixelRatio);
  if (density === 1) return '';
  if (density >= 3) return '@3x';
  return `@2x`;
}
